import React from 'react';
import pluralize from 'pluralize';
import { useNavigate } from '@tanstack/react-router';

import { formatDate } from '../../helpers';

import type { Memory } from '../../types/memory';
import type { Timeline } from '../../types/timeline';

interface MemoryTimelineItemProps {
  memory?: Memory;
  timelineMemory: Memory;
  timeline: Timeline;
  mode: 'public' | 'private';
}

const MemoryTimelineItem: React.FC<MemoryTimelineItemProps> = ({ memory, timelineMemory, timeline, mode }) => {
  const nav = useNavigate();

  return (
    <wa-card
      key={timelineMemory.id}
      className={`memory-timeline-memory ${timelineMemory.id === memory?.id ? ' active' : ''}`}
      onClick={() => {
        nav({ to: `/${mode === 'private' ? 'timelines' : 't'}/${timeline.id}/${timelineMemory.id}` })
      }}
    >
      <div className="memory-timeline-line-dot" />
      <div className="memory-timeline-line-date">
        {formatDate(timelineMemory.date, 'YYYY')}
      </div>
      <div className="memory-timeline-memory-title">
        {timelineMemory.title}
      </div>
      <div className="memory-timeline-memory-meta">
        <span>
          {formatDate(timelineMemory.date)}
        </span>
        <span>
          {pluralize('photo', timelineMemory.assets.length, true)}
        </span>
        {timelineMemory.id === memory?.id && (
          <span>
            viewing now
          </span>
        )}
      </div>
    </wa-card>
  );
}

export default MemoryTimelineItem;
